import { connect } from 'react-redux';
import { RootState } from '../reducers/root';
import { SustainabilityLabel } from '../components/SustainabilityPage/SustainabilityLabel';

const mapStateToProps = (state: RootState) => ({
  EcoLabel: state.FormulationSpace.SustainabilityData.EcoLabel,
});

export default connect(mapStateToProps)(SustainabilityLabel);
